import { Check, Star } from "lucide-react";
import { Reveal } from "./Reveal";
import { OPTIONS } from "../../data/smartContent";

const OptionCard = ({ option, index }) => {
  const { featured } = option;
  return (
    <div
      data-testid={`option-card-${index}`}
      className={`relative flex h-full flex-col rounded-3xl p-8 lg:p-10 bg-white ${
        featured ? "border-2 border-isic" : "border border-slate-200"
      }`}
    >
      <span
        className={`inline-flex w-fit items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wide ${
          featured ? "bg-isic text-white" : "bg-slate-100 text-slate-500"
        }`}
      >
        {featured && <Star size={12} fill="currentColor" />}
        {option.badge}
      </span>
      <h3 className="mt-6 font-serif text-2xl font-semibold text-ink">{option.title}</h3>
      <div className="mt-4 flex items-baseline gap-2">
        <span className="font-serif text-4xl font-semibold text-isic">{option.price}</span>
        <span className="text-sm text-slate-500">{option.priceNote}</span>
      </div>
      <ul className="mt-8 space-y-4 border-t border-slate-100 pt-8">
        {option.items.map((item) => (
          <li key={item} className="flex items-start gap-3">
            <span
              className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${
                featured ? "bg-isic text-white" : "bg-slate-200 text-slate-600"
              }`}
            >
              <Check size={12} strokeWidth={3} />
            </span>
            <span className="text-sm leading-relaxed text-slate-700">{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export const SmartLegitimare = () => (
  <section id="legitimare" data-testid="section-legitimare" className="scroll-mt-20 bg-white py-14 lg:py-20">
    <div className="mx-auto max-w-7xl px-5 lg:px-10">
      <div className="max-w-3xl mx-auto text-center">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-isic">Opțiuni disponibile</p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-4 font-serif text-3xl sm:text-4xl font-semibold leading-[1.15] text-ink">
            Variantele de legitimare
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-5 text-lg leading-relaxed text-slate-600">
            În cadrul programului ISIC Smart Campus sunt prevăzute două tipuri de legitimări care pot fi utilizate de
            către elevi, concepute pentru a permite implementarea proiectului la nivelul întregii instituții de
            învățământ. Fiecare elev sau părinte poate alege varianta pe care o consideră potrivită.
          </p>
        </Reveal>
      </div>

      <div className="mt-12 grid gap-6 lg:grid-cols-2 max-w-5xl mx-auto">
        {OPTIONS.map((option, i) => (
          <Reveal key={option.title} delay={i * 0.1}>
            <OptionCard option={option} index={i} />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
